class GiftWrapHandler extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.gift-wrap-checkbox');
    this.sectionId = this.dataset.sectionId;
    this.priceWrapper = document.querySelector(`#price-${this.sectionId}`);
    this.originalPriceCents = null;

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.onToggle.bind(this));
    }

    window.__giftWrapHandlers = window.__giftWrapHandlers || {};
    window.__giftWrapHandlers[this.sectionId] = this;
  }

  onToggle() {
    if (!this.priceWrapper) return;
    const priceEl = this.priceWrapper.querySelector('.price-item--regular, .price-item--last, .price-item');
    if (!priceEl) return;

    if (this.originalPriceCents === null) {
      this.originalPriceCents = this.parsePriceToCents(priceEl.textContent.trim());
      this.originalPriceText = priceEl.textContent.trim();
    }

    const giftWrapCents = parseInt(this.checkbox.dataset.price, 10);

    if (this.checkbox.checked) {
      priceEl.textContent = this.formatMoney(this.originalPriceCents + giftWrapCents);
    } else {
      priceEl.textContent = this.originalPriceText;
    }
  }

  parsePriceToCents(text) {
    const match = text.replace(/,/g, '').match(/(\d+)(?:\.(\d{1,2}))?/);
    if (!match) return 0;
    const rupees = parseInt(match[1], 10);
    const paise = match[2] ? parseInt(match[2].padEnd(2, '0'), 10) : 0;
    return rupees * 100 + paise;
  }

  formatMoney(cents) {
    const rupees = Math.floor(cents / 100);
    const paise = cents % 100;
    return 'Rs. ' + rupees.toLocaleString('en-IN') + '.' + String(paise).padStart(2, '0');
  }
}

customElements.define('gift-wrap-handler', GiftWrapHandler);

document.addEventListener(
  'click',
  async (event) => {
    const submitBtn = event.target.closest('.product-form__submit');
    if (!submitBtn) return;

    const form = submitBtn.closest('form');
    // NOTE: form.id use mat karo — form ke andar <input name="id"> hone se
    // form.id ek input element return karta hai, string nahi. Isliye getAttribute.
    const formId = form && form.getAttribute('id');
    if (!formId || !formId.startsWith('product-form-')) return;

    const sectionId = formId.replace('product-form-', '');
    const handler = window.__giftWrapHandlers && window.__giftWrapHandlers[sectionId];

    if (!handler || !handler.checkbox || !handler.checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (submitBtn.getAttribute('aria-disabled') === 'true') return;

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    const spinner = submitBtn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const formData = new FormData(form);
    const mainItem = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity'), 10) || 1,
    };
    const giftWrapItem = {
      id: handler.checkbox.dataset.variantId,
      quantity: 1,
    };

    const cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    const body = { items: [mainItem, giftWrapItem] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Cart add failed');
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(result);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else {
        window.location.reload();
        return;
      }

      handler.checkbox.checked = false;
      handler.onToggle();
    } catch (err) {
      console.error('Gift wrap add-to-cart error:', err);
      alert('Cart mein add karte waqt error aayi: ' + err.message);
    } finally {
      submitBtn.removeAttribute('aria-disabled');
      submitBtn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  },
  true
);